import { grey } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';
import { cyberpunk, night, ocean } from 'assets/colors';


export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: ocean,
          secondary: cyberpunk,
          text: {
            primary: grey[900],
            secondary: grey[800],
          },
          custom: {
            light: '#F3F3F3',
          },
        }
      : {
          // palette values for dark mode
          primary: night,
          divider: night[700],
        }),
  },
  shape: {
    borderRadius: 24,
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          th: {
            fontWeight: 600,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'inherit',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: night[500],
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: night[500],
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: night[500],
          color: 'white',
          hr: {
            backgroundColor: alpha(grey['50'], 0.2),
            margin: 8
          },
          li: {
            '&:hover': {
              background: `linear-gradient(90deg, transparent 0%, ${alpha(ocean[500], 0.15)} 30%, ${alpha(ocean[500], 1)} 200%)`,
            },
          },
          svg: {
            color: 'white',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: 'inherit',
          background: `linear-gradient(90deg, ${ocean[500]} -100%, ${cyberpunk[500]} 200%)`,
          '&:disabled': {
            background: grey['300']
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        subtitle1: {
          fontWeight: '500'
        },
        h6: {
          fontWeight: '600'
        },
        h5: {
          fontWeight: '600'
        }
      }
    }
  },
});
